var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridiconsCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0751 45.3291L27.5001 30.7312L12.9251 45.3291L9.6709 42.0749L24.2688 27.4999L9.6709 12.9249L12.9251 9.67078L27.5001 24.2687L42.0751 9.69369L45.3063 12.9249L30.7313 27.4999L45.3063 42.0749L42.0751 45.3291Z",
    fill: "#AA9767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsCross);
export default __webpack_public_path__ + "static/media/gridicons_cross.aa7a3619d31ea6aeb82165fa64eeea07.svg";
export { ForwardRef as ReactComponent };